module.exports = __webpack_public_path__ + "static/img/amg-1.a4f658d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/amg-1.jpg
// module id = 9OnA
// module chunks = 1